import BaseModel         from '@/lib/data/model/BaseModel'
import CountryResource  from '@/api/resources/user/CountryResource'

export default class CountryModel extends BaseModel {
  constructor (payload = {}, resource = CountryResource, validator = null) {
    super(payload, resource, validator)
  }

  boot () {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
}
